import {Table} from 'src/feature/bite/component'
import {useVIP} from '../../hook'
import {useState} from 'react'
import {useIntl} from 'react-intl'

const SelectedComponent = ({
  setSection,
  values,
}: {
  data?: any
  setSection: any
  values: any
  setFieldValue: any
}) => {
  const intl = useIntl()

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const {selectedGiveAwayProduct} = useVIP()

  const Columns = [
    {
      title: intl.formatMessage({id: 'GLOBAL.PRODUCT.CODE'}),
      key: 'code',
      dataIndex: 'code',
    },
    {
      title: intl.formatMessage({id: 'GLOBAL.PRODUCT.NAME'}),
      key: 'name',
      dataIndex: 'name',
    },
    {
      title: intl.formatMessage({id: 'GLOBAL.PRODUCT.CATEGORY'}),
      key: 'category',
      dataIndex: 'category',
    },
  ]

  const selectedGiveAwayProductPage = selectedGiveAwayProduct.slice(
    (page - 1) * pageSize,
    page * pageSize
  )

  return (
    <>
      <div>
        <div className='d-flex w-100 justify-content-between align-items-center gap-5 border rounded p-4 border-gray-300'>
          {selectedGiveAwayProduct.length === 0 && (
            <h4 className='mb-0'>{intl.formatMessage({ id: 'CAMPAIGN.PRODUCTS.NO_SELECTED' })}</h4>
          )}
          {selectedGiveAwayProduct.length > 0 && (
            <h4 className='mb-0'>{intl.formatMessage({ id: 'CAMPAIGN.PRODUCTS.SELECTED_PRODUCTS' }, { length: selectedGiveAwayProduct.length })}</h4>
          )}
          <div className='d-flex gap-5'>
            <button
              className='btn border border-primary rounded-pill'
              disabled={values.priceCluster.length === 0}
              onClick={() => {
                setSection(3)
              }}
            >
              {intl.formatMessage({ id: 'CAMPAIGN.PRODUCTS.SELECT' })}
            </button>
          </div>
        </div>
        {/* <div className='d-flex w-100 justify-content-between gap-5 mt-10'>
          <h2>{intl.formatMessage({id: 'CAMPAIGN.PRODUCTS.SELECTED'})}</h2>
          <div className='d-flex gap-5'>
            <button
              className='btn border border-primary rounded-pill'
              disabled={values.priceCluster.length === 0}
              onClick={() => {
                setSection(3)
              }}
            >
              {intl.formatMessage({id: 'CAMPAIGN.PRODUCTS.SELECT'})}
            </button>
          </div>
        </div>
        <Table
          dataSource={selectedGiveAwayProductPage}
          columns={Columns}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: selectedGiveAwayProduct.length,
            onChange: (pagination: {current: number; pageSize: number; total: number}) => {
              setPage(pagination.current)
              setPageSize(pagination.pageSize)
            },
          }}
        /> */}
      </div>
    </>
  )
}

export default function CampaignProductsGiveAway({Field, values, setSection, setFieldValue}: any) {
  return (
    <div className='card-body mt-5 pt-0'>
      <SelectedComponent setSection={setSection} values={values} setFieldValue={setFieldValue} />
    </div>
  )
}
